import React from 'react';
import { Grid, Container } from '@material-ui/core';
import { MedicalSupplies } from '../../components';

const VetMedicalSuppliesPage: React.FC<any> = () => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MedicalSupplies />
        </Grid>
      </Grid>
    </Container>
  );
};

export default VetMedicalSuppliesPage;
